<mat-icon (click)="gaaTilAvstemningerForMoete()" fontSet="ion-ios-calendar-outline" class="panel-entitet-ikon mat-icon--ionic-ikon"/>
<a (click)="gaaTilAvstemningerForMoete()" class="tittel" data-testid="møtenavn">
  {{ manglerStemmegivning().moete.tittel }} {{ manglerStemmegivning().moete.nummer }}, {{ manglerStemmegivning().moete.dato.start | zoneddatetimeSomPlaindate|plaindate }}
  ({{ '{antall} avstemninger'|translate:{antall: manglerStemmegivning().antallAvstemninger} }})
</a>
<div (click)="visEllerSkjulAvstemningstatus()" class="antall-stemmer" data-testid="vis-status-knapp">
  {{ '{antall} av {total} medlemmer har fullført'|translate:{antall: antallSomHarFullfoert(), total: manglerStemmegivning().stemmegivere.length} }}
</div>
@if (viserStemmegivere()) {
  <div class="stemmegivere" @fadeInn data-testid="stemmegivere">
    @for (stemmegiver of manglerStemmegivning().stemmegivere; track stemmegiver.medlem.id) {
      <div class="rad">
        <avatar [medlem]="stemmegiver.medlem"/>
        <div data-testid="navn">{{ stemmegiver.medlem.navn }}</div>
        <div class="statusfelt" data-testid="status">{{ stemmegiver.status | enum:'StemmegivningStatus' }}</div>
      </div>
    }
  </div>
}
